import React from 'react';
import { GroupSortBy } from 'types/groupService';
import DashboardTableHeader from 'components/groups-dashboard/DashboardTableHeader';

const GroupsTableHeader: React.FC = () => {
  const headings = [
    { title: 'Group Name', width: '15%', sorting: true, sortingKey: GroupSortBy.NAME },
    { title: 'Effective Dates', sorting: true, sortingKey: GroupSortBy.EFFECTIVE_DATE },
    { title: 'Product Lines' },
    { title: 'Stage' },
    { title: 'Assigned' },
    { title: 'Modified', sorting: true, sortingKey: GroupSortBy.UPDATE_TIME },
    { title: '' },
  ];
  return <DashboardTableHeader headings={headings} />;
};

export default GroupsTableHeader;
